import { render, staticRenderFns } from "./course-equivalent-files.vue?vue&type=template&id=77749ca9&"
import script from "./course-equivalent-files.vue?vue&type=script&lang=js&"
export * from "./course-equivalent-files.vue?vue&type=script&lang=js&"
import style0 from "./course-equivalent-files.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports